import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Benefits } from './components/Benefits';
import { Process } from './components/Process';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <Hero data-id="element-2" />
      <Benefits data-id="element-3" />
      <Process data-id="element-4" />
      <Testimonials data-id="element-5" />
      <Pricing data-id="element-6" />
      <FAQ data-id="element-7" />
      <CTA data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}